export function getIdByLastSlash(string) {
  const parts = string.split('/');
  const answer = parts[parts.length - 1];

  if (!Number.isInteger(parseInt(answer, 10))) return null;
  return answer;
}
